import React from 'react';
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

interface TrendChartProps {
  data: Array<{ label: string; value: number }>;
  loading?: boolean;
}

function AxisTick({ x, y, payload }: any) {
  return (
    <text x={x} y={y + 12} fill="var(--text-muted)" fontSize="11" style={{ fontFamily: 'DM Mono' }} textAnchor="middle">
      {payload.value}
    </text>
  );
}

function ValueTick({ x, y, payload }: any) {
  return (
    <text x={x - 10} y={y + 4} fill="var(--text-muted)" fontSize="11" style={{ fontFamily: 'DM Mono' }} textAnchor="end">
      {payload.value}
    </text>
  );
}

function ChartTooltip({ active, payload, label }: any) {
  if (!active || !payload || !payload.length) {
    return null;
  }

  return (
    <div className="chart-tooltip">
      <div className="chart-tooltip__label">{label}</div>
      <div className="chart-tooltip__value">{payload[0].value.toFixed(1)}h</div>
    </div>
  );
}

export function TrendChart({ data, loading }: TrendChartProps) {
  return (
    <section className="panel-card trend-card">
      <div className="card-header">
        <div>
          <div className="section-kicker">Daily coding trend</div>
          <h3>Rolled up from daily summaries</h3>
          <p>Area chart of coding time over the selected range.</p>
        </div>
      </div>

      {loading ? (
        <div className="chart-loading">
          <div className="skeleton-line skeleton-line--xl" />
          <div className="skeleton-line skeleton-line--xl" />
          <div className="skeleton-line skeleton-line--xl" />
        </div>
      ) : (
        <div className="trend-chart-wrap">
          <ResponsiveContainer width="100%" height={320}>
            <AreaChart data={data} margin={{ top: 20, right: 8, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="founderpulseChartFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="var(--chart-line)" stopOpacity={0.22} />
                  <stop offset="95%" stopColor="var(--chart-line)" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="label" axisLine={false} tickLine={false} tick={<AxisTick />} />
              <YAxis axisLine={false} tickLine={false} tick={<ValueTick />} />
              <Tooltip content={<ChartTooltip />} cursor={false} />
              <Area
                type="monotone"
                dataKey="value"
                stroke="var(--chart-line)"
                fill="url(#founderpulseChartFill)"
                strokeWidth={2}
                dot={{ r: 3, fill: 'var(--accent-green)', stroke: 'var(--accent-green)', strokeWidth: 0 }}
                activeDot={{ r: 5, fill: 'var(--accent-green)' }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </section>
  );
}
